export const BASE_URL =
  process.env.BASE_URL || "https://ykl239vt18.execute-api.ap-south-1.amazonaws.com/prod/v1/"
